import { TThunkAction } from '../../types/redux';
import { notify } from '../../actions/notifications';
import { ENotificationStyle } from '../../types/notifications';
import { fetchCreateFolder } from '../../repositories/favorites/v1/create-folder';
import { addFolder } from '../../actions/folders/actions';

export interface ICreateFolderRequest {
  name: string;
}

export const createFolder = (name: string): TThunkAction<Promise<void>> => async (
  dispatch,
  getState,
  { httpApi, logger },
) => {
  const parameters: ICreateFolderRequest = {
    name,
  };

  const showError = () => dispatch(notify('Не удалось создать подборку', ENotificationStyle.Error));

  try {
    const { statusCode, response } = await fetchCreateFolder({ httpApi, parameters });

    if (statusCode === 200) {
      dispatch(addFolder({ id: response.id, name: response.name }));
    }

    if (statusCode === 400) {
      showError();
      logger.warning(response.message);
    }
  } catch (e) {
    showError();
    logger.error(e, {
      description: 'Fail to create favorites folder',
    });
  }
};
